'use client';

// import { Info } from 'lucide-react';
import { useLanguage } from '@/contexts/language-context';
import { useSidebar } from '@/contexts/sidebar-context';
import { useAuth } from '@/contexts/auth-context';
import { LoginButton } from './login-dialog';
import { MembershipTierEntry } from './membership-tiers-dialog';
import { SocialLinks } from './social-links';
// import { toast } from 'sonner';

export default function Header() {
  const { isRTL } = useLanguage();
  const { isOpen } = useSidebar();
  const { isLogin } = useAuth();
  const desktopOffsetClass = isRTL ? (isOpen ? 'md:right-[280px]' : '') : isOpen ? 'md:left-[280px]' : '';

  return (
    <header
      dir={isRTL ? 'rtl' : 'ltr'}
      className={`fixed left-0 right-0 top-0 z-40 h-16 bg-[#070400] transition-all duration-300 md:z-50 ${desktopOffsetClass}`}>
      <div className="flex h-16 items-center justify-end px-3 sm:px-6 lg:px-8">
        <div className="flex min-w-0 items-center gap-1 sm:gap-3">
          {/* <Button
            variant="ghost"
            size="icon"
            className="text-white/70 hover:text-white hover:bg-white/[0.1] transition-colors"
            onClick={() => window.open('https://v-agentcode.github.io/v-agent/', '_blank', 'noopener,noreferrer')}
            aria-label="Info">
            <Info className="w-5 h-5" />
          </Button> */}
          <MembershipTierEntry />
          <SocialLinks />
          {!isLogin && <LoginButton />}
          {/* <button
            className="text-white"
            onClick={() =>
              toast.success('Success', {
                position: 'top-center',
                duration: 500000,
              })
            }>
            toast
          </button> */}
        </div>
      </div>
    </header>
  );
}
